export const GET_ITEMS = "GET_ITEMS";
export const GET_CARDITEMS = "GET_CARDITEMS";
export const GET_ITEM = "GET_ITEM";
export const GET_ITEMLIST = "GET_ITEMLIST";
export const ADD_ITEM = "ADD_ITEM";
export const DELETE_ITEM = "DELETE_ITEM";
export const UPDATE_ITEM = "UPDATE_ITEM";
export const ITEM_KANBAN_BLOB = "ITEM_KANBAN_BLOB";
export const ITEMS_LOADING = "ITEMS_LOADING";
export const ITEM_LOCK = "ITEM_LOCK";
export const ITEM_NOTIFICATION = "ITEM_NOTIFICATION";
export const ITEM_ERROR = "ITEM_ERROR";
export const ITEM_BACKUP = "ITEM_BACKUP";
export const ITEM_UPDATE_PERCENTAGE = "ITEM_UPDATE_PERCENTAGE";
// export const ITEM_CACHE = "ITEM_CACHE";
export const BASELINE_NOTIFICATION = "BASELINE_NOTIFICATION";
export const DELETE_OLD_ITEMS = "DELETE_OLD_ITEMS";
export const ITEM_UNLOCK = "ITEM_UNLOCK";
export const COPY_TASKS = "COPY_TASKS";
export const DELETE_LOCAL_ITEMS = "DELETE_LOCAL_ITEMS";
export const ADD_BASELINE = "ADD_BASELINE";
export const GET_BASELINE = "GET_BASELINE";

export const SEND_NOTIFICATION = "SEND_NOTIFICATION";

export const USER_LOADING = "USER_LOADING";
export const USER_LOADED = "USER_LOADED";
export const USER_UPDATE_ERROR = "USER_UPDATE_ERROR";
export const USER_UPDATE_SUCCESS = "USER_UPDATE_SUCCESS";
export const USER_UPDATED = "USER_UPDATED";
export const USER_CHANGE_LANGUAGE = "USER_CHANGE_LANGUAGE";
export const USER_NOTIFICATION = "USER_NOTIFICATION";
export const USER_PASSWORD = "USER_PASSWORD";
export const USER_PRICING = "USER_PRICING";
export const USER_SELECTION = "USER_SELECTION";
export const USER_HISTORY = "USER_HISTORY";
export const USER_RECORDER = "USER_RECORDER";
export const USER_CHAT_TOKEN = "USER_CHAT_TOKEN";

export const NEW_CHAT = "NEW_CHAT";
export const UPDATE_CHAT = "UPDATE_CHAT";

export const SHARE_UPDATE_USER_LIST = "SHARE_UPDATE_USER_LIST";
export const SHARE_GET_USER_LIST = "SHARE_GET_USER_LIST";

export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_NOTIFICATION = "LOGIN_NOTIFICATION";
export const RESET_AUTH_USER = "RESET_AUTH_USER";
export const RESET_PWD_USER = "RESET_PWD_USER";
export const REMOVE_GREETINGS = "REMOVE_GREETINGS";

export const WEBSOCKET_CONNECTED = "WEBSOCKET_CONNECTED";
export const WEBSOCKET_MESSAGE_RECEIVED = "WEBSOCKET_MESSAGE_RECEIVED";
export const WEBSOCKET_DISCONNECTED = "WEBSOCKET_DISCONNECTED";
export const WEBSOCKET_NEW_CONNECTION = "WEBSOCKET_NEW_CONNECTION";

export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_ERROR = "LOGOUT_ERROR";
export const LOGOUT_NOTIFICATION = "LOGOUT_NOTIFICATION";

export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const REGISTER_ERROR = "REGISTER_ERROR";
export const REGISTER_NOTIFICATION = "REGISTER_NOTIFICATION";

export const GET_ERRORS = "GET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const PWD_UPDATE_SUCCESS = "PWD_UPDATE_SUCCESS";
export const PWD_UPDATE_ERROR = "PWD_UPDATE_ERROR";
export const FIRST_CONNECTION = "FIRST_CONNECTION";
export const VALIDATE_EMAIL = "VALIDATE_EMAIL";
export const RESEND_EMAIL_VALIDATION = "RESEND_EMAIL_VALIDATION";
// export const RESEND_EMAIL_VALIDATION_SUCCESS = "RESEND_EMAIL_VALIDATION";
export const EMAIL_VALIDATION_SUCCESS = "EMAIL_VALIDATION_SUCCESS";
export const EMAIL_VALIDATION_FAIL = "EMAIL_VALIDATION_FAIL";
export const EMAIL_SEND_CRM = "EMAIL_SEND_CRM";
export const SEND_INVITATION = "SEND_INVITATION";

export const SEND_CONTACTFORM = "SEND_CONTACTFORM";

export const GET_ELEMENTS = "GET_ELEMENTS";
export const ADD_ELEMENT = "ADD_ELEMENT";
export const DELETE_ELEMENT = "DELETE_ELEMENT";
export const ELEMENTS_LOADING = "ELEMENTS_LOADING";
export const UPDATE_ELEMENT = "UPDATE_ELEMENT";

export const GET_TOOLS = "GET_TOOLS";
export const ADD_TOOL = "ADD_TOOL";
export const DELETE_TOOL = "DELETE_TOOL";
export const TOOLS_LOADING = "TOOLS_LOADING";

export const GET_MENU = "GET_MENU";
export const MENU_LOADING = "MENU_LOADING";

export const EXPAND_TOOLS = "EXPAND_TOOLS";

export const GET_PROJECTS = "GET_PROJECTS";
export const ADD_PROJECT = "ADD_PROJECT";
export const DELETE_PROJECT = "DELETE_PROJECT";
export const PROJECTS_LOADING = "PROJECTS_LOADING";
export const UPDATE_PROJECT = "UPDATE_PROJECT";
export const UPDATE_CONTACTLIST = "UPDATE_CONTACTLIST";
export const PROJ_ERROR = "PROJ_ERROR";
export const PROJECT_NOTIFICATION = "PROJECT_NOTIFICATION";
export const ADD_FOLDER = "ADD_FOLDER";
export const MODIFY_FOLDER = "MODIFY_FOLDER";
export const DELETE_FOLDER = "DELETE_FOLDER";
export const UPDATE_FOLDER = "UPDATE_FOLDER";
export const ITEM_COOLDOWN = "ITEM_COOLDOWN";

export const CHANGE_PAGE = "CHANGE_PAGE";
export const CHANGE_PROJ = "CHANGE_PROJ";
export const CHANGE_CARD = "CHANGE_CARD";
export const CHANGE_ITEM = "CHANGE_ITEM";
export const CHANGE_LAN = "CHANGE_LAN";
export const DISPLAY_FOOTER = "DISPLAY_FOOTER";

export const GET_CARDS = "GET_CARDS";
export const ADD_CARD = "ADD_CARD";
export const DELETE_CARD = "DELETE_CARD";
export const CARDS_LOADING = "CARDS_LOADING";
export const UPDATE_CARD = "UPDATE_CARD";

export const UPDATE_FAVORITE = "UPDATE_FAVORITE";
export const FAVORITES_LOADING = "FAVORITES_LOADING";
export const GET_FAVORITES = "GET_FAVORITES";
export const DELETE_FAVORITE = "DELETE_FAVORITE";

export const SENT_EMAIL = "SENT_EMAIL";
export const REGISTER_EMAIL = "REGISTER_EMAIL";

export const SAVE_IMAGE = "SAVE_IMAGE";
export const DELETE_IMAGES = "DELETE_IMAGES";

export const UPLOAD_PICTURE = "UPLOAD_PICTURE";
export const DOWNLOAD_PICTURE = "DOWNLOAD_PICTURE";
// export const PICTURE_UPLOAD_SUCCESS = "PICTURE_UPLOAD_SUCCESS";
// export const PICTURE_UPLOAD_ERROR = "PICTURE_UPLOAD_ERROR";
export const PICTURE_NOTIFICATION = "PICTURE_NOTIFICATION";
export const PICTURE_ERROR = "PICTURE_ERROR";
export const DELETE_PROFILE_PICTURE = "DELETE_PROFILE_PICTURE";

export const FILE_UPLOAD_SUCCESS = "FILE_UPLOAD_SUCCESS";
export const FILE_DELETE_SUCCESS = "FILE_DELETE_SUCCESS";
export const FILE_SAVE = "FILE_SAVE";
export const FILE_DOWNLOAD_NOTIFICATION = "FILE_DOWNLOAD_NOTIFICATION";
export const FILE_UPLOAD_NOTIFICATION = "FILE_UPLOAD_NOTIFICATION";
export const FILE_UPLOAD_ERROR = "FILE_UPLOAD_ERROR";

export const ADMIN_FUNCTION = "ADMIN_FUNCTION";
export const UPDATE_CONTACTS = "UPDATE_CONTACTS";

export const ACCEPT_COOKIES = "ACCEPT_COOKIES";

export const WS_CONNECT = "WS_CONNECT";
export const WS_DISCONNECT = "WS_DISCONNECT";
export const WS_TASK_UPDATE = "WS_TASK_UPDATE";

export const GET_PERSONAL_INFO = "GET_PERSONAL_INFO";
export const LOAD_PERSONAL_INFO = "LOAD_PERSONAL_INFO";
export const POST_PERSONAL_INFO = "POST_PERSONAL_INFO";

export const GET_MANAGER_INFO = "GET_MANAGER_INFO";
export const LOAD_MANAGER_INFO = "LOAD_MANAGER_INFO";
export const COOLDOWN_MANAGER_INFO = "COOLDOWN_MANAGER_INFO";

export const COMPANY_NOTIFICATION = "COMPANY_NOTIFICATION";
export const GET_COMPANY = "GET_COMPANY";
export const ADD_COMPANY = "ADD_COMPANY";
export const UPDATE_COMPANY = "UPDATE_COMPANY";
export const DELETE_COMPANY = "DELETE_COMPANY";

export const GET_CLIENT = "GET_CLIENT";

export const BUSINESSCARD_NOTIFICATION = "BUSINESSCARD_NOTIFICATION";

export const MEETING_MINUTES_NOTIFICATION = "MEETING_MINUTES_NOTIFICATION";
